import TNotificationGroup from '../types/TNotificationGroup';

export type TMarkNotificationAtIndexAsRead = {
  ids: string[];
  newNotifications: TNotificationGroup[];
};

/* 
  An entry in the tray can either be a single or a group of notifications.
  This function handles marking that entry as read.
*/
export const markNotificationAtIndexAsRead = (
  index: number,
  notificationGroups: TNotificationGroup[]
): TMarkNotificationAtIndexAsRead => {
  const ids: string[] = [notificationGroups[index].titleNotification.notificationId];
  const clonedNotificationGroups = structuredClone(notificationGroups);
  clonedNotificationGroups[index].titleNotification.read = true;

  clonedNotificationGroups[index].children = clonedNotificationGroups[index].children.map(child => {
    ids.push(child.notificationId);
    const newChild = { ...child, read: true };
    return newChild;
  });

  return { ids, newNotifications: clonedNotificationGroups };
};
